<template lang="pug" src="./edit/template.pug"></template>
<script>

  import {now, parseDateTime, DateTime, Settings} from '../../lib/dates'
  import {countries, states, get$} from '../../lib/utils'
  Settings.defaultLocale = "en-us"

  import {Datetime} from 'vue-datetime-extended'
  import 'vue-datetime-extended/dist/vue-datetime-extended.css'

  import ConfigMixin from '../../components/_mixins/config'
  import PageMixin from '../../components/_mixins/pages'
  import {ValidationMixins, setValidationRule, parseValidationSetup, parseValidations} from '../../lib/validations'

  import MainService from '../../services/main'

  import ResetPasswordPrompt from '../../components/global/reset-password-prompt'

  const components = {ResetPasswordPrompt, Datetime}

  const validations = {
    firstName: setValidationRule('firstName'),
    racerName: setValidationRule('racerName'),
    lastName: setValidationRule('lastName'),
    email: setValidationRule('email', {
      required: {error: 'Email is required.'},
      email: {error: 'Email is not valid.'},
    }),
    birthDate: setValidationRule('birthDate', {
       valid: {
         error: 'Birth date is not valid',
         rule: date => {
            return parseDateTime(date).isValid
          }
       },
    }),
    address1: setValidationRule('address1', 'Address'),
    address2: setValidationRule('address2', 'Address Line 2'),
    city: setValidationRule('city'),
    state: setValidationRule('state'),
    zip: setValidationRule('zip'),
    country: setValidationRule('country'),
    phone: setValidationRule('phone', 'Mobile phone'),
  }

  export default {
    settings: 'page.profile.tab.edit',
    translations: 'page.profile.tab.edit',
    mixins: [
      ConfigMixin,
      PageMixin,
      ValidationMixins
    ],
    components,
    data: () => ({
      now: now.toISODate(),

      firstName: null,
      lastName: null,
      racerName: null,

      gender: null,
      birthDate: null,
      email: null,
      phone: null,


      address1: null,
      address2: null,
      city: null,
      country: null,
      state: null,
      zip: null,

      subscribe: null,
      smsSubscribe: null,

      countries,
      states,
      isProcessing: null,
      errorMessage: null,
      passwordHasBeenReset: null,
      showProfileUpdatedMessage: null,
      validations
    }),

    validations: parseValidations(validations),

    computed: {
      user() {
        return this.authUser
      },
    },

    created() {
      parseValidationSetup(this.validations, this)
      const user = this.user
      const meta = user.meta

      this.email = user.email
      this.firstName = user.first_name
      this.lastName = user.last_name
      this.racerName = meta.clubspeed_racername

      this.birthDate = meta.birth_date

      this.gender = meta.gender
      this.phone = meta.phone
      this.address1 = meta.address
      this.address2 = meta.address2
      this.city = meta.city
      this.country = meta.country
      this.state = meta.state
      this.zip = meta.zip
      this.subscribe = meta.subscribe
      this.smsSubscribe = meta.sms_subscribe
    },

    methods: {
      showChangePasswordPrompt() {
        this.passwordHasBeenReset = null
        this.showResetPassword(true)

      },
      async savePersonal() {
        // this.$v[validationGroup].$touch()

        this.$v.$touch()
        this.formSubmitting = true

        if (this.isAnyInvalid) { // if (!this.$v[validationGroup].$anyError) {
          // console.log('error')
          this.scrollToFirstErrorElement()
        } else {
          const payload = {
            email: this.email,
            first_name: this.firstName,
            last_name: this.lastName,
            clubspeed_racername: this.racerName,
            birth_date: this.birthDate,
            gender: this.gender,
            phone: this.phone,

            address: this.address1,
            address2: this.address2,
            city: this.city,
            country: this.country,
            state: this.state,
            zip: this.zip,

            subscribe: this.subscribe,
            sms_subscribe: this.smsSubscribe,

          }

          await this.submit(payload, "personalGroup", "isProcessing")
        }
      },

      async submit(payload, validationGroup, savingProperty) {

        this.errorMessage = null
        try {
          this.$set(this, savingProperty, true)
          const {data: user = {}} = await MainService.updateUser(this.user.id, payload)
          this.showProfileUpdatedMessage = true
          this.$store.dispatch("updateUser", {user})
        } catch (e) {
          this.errorMessage = MainService.getFirstErrorMessage(e)
          this.scrollTo(get$('.page-profile'))
        } finally {
          this.$set(this, savingProperty, false)
        }

      },
    },
  }
</script>
